import { render, staticRenderFns } from "./PreferenciasServentia.vue?vue&type=template&id=0d18af60&"
import script from "./PreferenciasServentia.vue?vue&type=script&lang=js&"
export * from "./PreferenciasServentia.vue?vue&type=script&lang=js&"
import style0 from "./PreferenciasServentia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports